let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("rw8p1")).then(() => parcelRequire('hOsWM'));